import { StyleSheet } from 'react-native';
import { pt, px } from '../common/utils';
import { JDDevice } from '@jdreact/jdreact-core-lib';

export default StyleSheet.create({
    container: {
        backgroundColor: '#f5f5f5',
        width: pt(375),
        flex: 1
    },
    body: {
        flex: 1
    },
    scale_info: {
        padding: pt(5),
        backgroundColor: '#fff',
        // borderTopWidth: px(2),
        // borderColor: '#0001',
        paddingVertical: pt(10)
    },
    dialogBody: {
        padding: pt(20)
    },
    top: {
        padding: pt(15),
        paddingBottom: pt(10),
        backgroundColor: '#fff',
        // borderBottomWidth: px(2),
        // borderColor: '#0001',
        position: 'relative',
        marginBottom: pt(5)
    },
    mov_name: {
        color: '#000',
        fontSize: pt(16),
        height: pt(25),
        justifyContent: 'center'
    },
    mov_info_top: {
        color: '#252525',
        fontSize: pt(12),
        marginTop: pt(5),
        minHheight: pt(17)
    },
    mov_info: {
        color: '#666',
        fontSize: pt(12),
        marginTop: pt(5)
    },
    // tel
    tel: {
        flexDirection: 'row',
        padding: pt(10),
        justifyContent: 'flex-start',
        backgroundColor: '#fff',
        marginTop: pt(5),
        alignItems: 'center',
        paddingHorizontal: pt(15),
        height: pt(44)
    },
    tel_name: {
        color: '#252525',
        fontSize: pt(14),
        marginRight: pt(10)
    },
    tel_txt: {
        color: '#252525',
        fontSize: pt(14),
        fontWeight: 'bold'
    },
    // bottom
    b_info: {
        justifyContent: 'space-between',
        flexDirection: 'row',
        height: pt(46),
        backgroundColor: '#fff',
        alignItems: 'center',
        padding: pt(10)
    },
    eixt: {
        flexDirection: 'row'
    },
    e_info: {
        justifyContent: 'center',
        marginRight: pt(18),
        flexDirection: 'row',
        alignItems: 'center'
    },
    e_img: {
        marginRight: pt(3),
        height: pt(13),
        width: pt(13)
    },
    e_text: {
        fontSize: pt(12)
    },
    price: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'flex-end'
        // marginTop: pt(-1)
    },
    t_head: {
        fontSize: pt(12),
        color: '#252525',
        marginRight: pt(5)
    },
    t_pic: {
        fontSize: pt(14),
        color: '#E2231A',
        fontWeight: 'bold',
        marginBottom: pt(-2)
    },
    t_price: {
        fontSize: pt(20),
        // lineHeight: pt(20),
        color: '#E2231A',
        fontWeight: 'bold',
        marginBottom: pt(-3)
    },
    right: {
        alignSelf: 'center',
        marginLeft: pt(3),
        height: pt(4),
        width: pt(11)
    },
    agreen: {
        height: pt(50),
        backgroundColor: '#FF2000',
        justifyContent: 'center',
        alignItems: 'center'
    },
    agreen_txt: {
        fontSize: pt(16),
        color: '#fff',
        backgroundColor: 'transparent'
    },
    gray: {
        color: '#bbb'
    },

    // promotion
    all_list: {
        padding: pt(10),
        paddingHorizontal: pt(10),
        backgroundColor: '#fff'
    },
    list: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        // height: pt(30),
        padding: pt(5),
        alignItems: 'center'
    },
    card: {
        paddingTop: 0,
        borderBottomWidth: px(1),
        borderColor: 'rgba(0, 0, 0, 0.1)',
        paddingBottom: pt(15)
    },
    left: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    c_txt: {
        marginRight: pt(6),
        fontSize: pt(14)
    },
    s_price: {
        fontSize: pt(14),
        color: '#E2231A',
        marginRight: pt(5)
    },
    v_scale: {
        height: pt(15),
        width: pt(14),
        backgroundColor: '#F56A00',
        borderRadius: pt(2),
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: pt(2)
    },
    scale: {
        color: '#fff',
        fontSize: pt(10)
    },
    scale_txt: {
        color: '#000',
        width: pt(270),
        fontSize: pt(14),
        marginLeft: pt(5)
    },

    orange: {
        backgroundColor: '#F56A00'
    },
    greenBg: {
        backgroundColor: '#0AAD48',
    },
    bg2B84FF: {
        backgroundColor: '#2B84FF'
    },
    orange_txt: {
        color: '#F56A00'
    },
    greenTxt: {
        color: '#0AAD48',
    },
    blue_txt: {
        color: '#2B84FF'
    },
    // coupon
    coupon: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: pt(10),
        paddingTop: pt(5),
        height: pt(35),
        // paddingTop: pt(0),
        alignItems: 'center',
        backgroundColor: '#fff'
    },
    sc_txt: {
        fontSize: pt(14),
        marginRight: pt(5)
    },
    v_coupon: {
        borderRadius: pt(4),
        paddingHorizontal: pt(5),
        paddingVertical: pt(3),
        justifyContent: 'center',
        alignItems: 'center',
        height: pt(18)
    },
    is_coupon: {
        color: '#fff',
        fontSize: pt(12)
    },
    no_coupon: {
        // fontSize: pt(12),
        backgroundColor: 'rgba(217, 217, 217, 1)',
        borderRadius: pt(3),
        height: pt(18),
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: pt(5)
    },
    can_coupon: {
        // fontSize: pt(12),
        backgroundColor: '#E2231A'
    },
    // licence
    licence: {
        flexDirection: 'row',
        padding: pt(10),
        paddingHorizontal: pt(15),
        justifyContent: 'flex-start',
        backgroundColor: '#fff',
        marginTop: pt(5),
        alignItems: 'center',
        height: pt(44)
    },
    licence_text: {
        fontSize: pt(12),
        color: '#898989'
    },
    blue: {
        fontSize: pt(12),
        color: '#60A8FE'
    },
    right_arrow: {
        height: pt(11),
        width: pt(4)
    },
    agreement_style: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        zIndex: 1000
    },
    panel: {
        position: 'relative',
        zIndex: 1002,
        margin: pt(40),
        top: pt(-50)
    },
    agreement_top: {
        width: pt(295),
        height: pt(466),
        padding: pt(24),
        borderRadius: pt(24),
        backgroundColor: 'rgba(255,255,255,1)',
    },
    agreement_opacity: {
        height: JDDevice.height,
        width: JDDevice.width,
        backgroundColor: 'rgba(0,0,0,0.7)',
        position: 'absolute',
        zIndex: 1001,
    },
    agreement_title: {
        fontSize: pt(16),
        color: 'rgba(26,26,26,1)',
        fontWeight: 'bold',
        textAlign: 'center',
        fontFamily: 'PingFang SC',
        marginBottom: pt(8),
    },
    agreement_content: {
        width: pt(247),
        height: pt(295),
        fontSize: pt(14),
        fontFamily: 'PingFang SC',
        fontWeight: 'normal',
        color: 'rgba(26,26,26,1)',
        overflow: 'scroll',
        paddingBottom: pt(20)
    },
    agreement_button: {
        borderRadius: pt(16),
        width: pt(247),
        height: pt(32),
        marginTop: pt(8),
        backgroundColor: 'rgba(250,44,25,1)',
    },
    agreement_oremind: {
        marginTop: pt(8),
        fontSize: pt(12),
        color: 'rgba(26,26,26,1)',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        alignContent: 'center'
    },
    agreement_oremind_img: {
        width: pt(12),
        height: pt(12),
        marginRight: pt(2)
    },
    agreement_oremind_text: {},
    agreement_refuse: {
        fontSize: pt(14),
        textAlign: 'center',
        color: 'rgba(255,255,255,1)',
        fontWeight: 'normal',
        marginTop: pt(15),
        width: pt(295),
        left: 0
    },
    agreement_refuse_txt: {
        width: pt(295),
        textAlign: 'center',
        position: 'relative',
        color: 'rgba(255,255,255,1)',
    }
});
